class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[type="submit"]');
    if (!this.form || !this.button) return;
    this.form.addEventListener('submit', async (event) => {
      event.preventDefault();
      this.button.setAttribute('aria-busy', 'true');
      const original = this.button.textContent;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        if (!response.ok) throw new Error('cart');
        this.button.textContent = this.button.dataset.added;
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        setTimeout(() => { this.button.textContent = original; }, 1800);
      } catch (error) {
        this.form.submit();
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    });
  }
}
customElements.define('product-form', ProductForm);

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const root = select.closest('[data-product-root]');
  const price = root.querySelector('[data-product-price]');
  const button = root.querySelector('[type="submit"]');
  if (price) price.textContent = option.dataset.price;
  if (button) button.disabled = option.dataset.available !== 'true';
});
